import React, { useState } from "react";
import {
  Animated,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { FontAwesome5, Ionicons } from "@expo/vector-icons";
import { useRouter } from "expo-router";

import HelpSupportModal from "../Support/SupportModal";

function ExpandableOptions(): React.JSX.Element {
  const router = useRouter();
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [optionsHeight] = useState(new Animated.Value(0));
  const [isSupportModalVisible, setSupportModalVisible] =
    useState<boolean>(false);

  const toggleOptions = (): void => {
    setShowOptions(!showOptions);
    Animated.timing(optionsHeight, {
      toValue: showOptions ? 0 : 1,
      duration: 300,
      useNativeDriver: false,
    }).start();
  };

  const onCreateAccount = (): void => {
    router.push("/(authentication)/sign-up");
  };

  const onForgotPassword = (): void => {
    router.push("/(authentication)/forgot-password");
  };

  const onVerifyAccount = (): void => {
    router.push("/(authentication)/verify-account");
  };

  const onHelpSupport = (): void => {
    setSupportModalVisible(true);
  };

  const closeSupportModal = (): void => {
    setSupportModalVisible(false);
  };

  return (
    <View style={[styles.container]}>
      <TouchableOpacity
        style={[styles.toggleButton]}
        onPress={toggleOptions}
        testID="toggle-options-button"
      >
        <Text style={[styles.toggleButtonText]}>
          {showOptions ? "Hide options" : "More options"}
        </Text>
        <FontAwesome5
          name={showOptions ? "chevron-up" : "chevron-down"}
          size={16}
          color="#4299E1"
        />
      </TouchableOpacity>

      <Animated.View
        style={[
          styles.optionsContainer,
          {
            maxHeight: optionsHeight.interpolate({
              inputRange: [0, 1],
              outputRange: [0, 300], // Adjust this value based on your content
            }),
            opacity: optionsHeight,
          },
        ]}
      >
        <TouchableOpacity style={styles.optionButton} onPress={onCreateAccount}>
          <FontAwesome5 name="user-circle" size={25} color="#4299E1" />
          <Text style={styles.optionText}>Create Account</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.optionButton}
          onPress={onForgotPassword}
        >
          <Ionicons name="key-outline" size={25} color="#4299E1" />
          <Text style={styles.optionText}>Forgot Password</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.optionButton} onPress={onVerifyAccount}>
          <FontAwesome5 name="check-circle" size={25} color="#4299E1" />
          <Text style={styles.optionText}>Verify Account</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.optionButton} onPress={onHelpSupport}>
          <FontAwesome5 name="question-circle" size={25} color="#4299E1" />
          <Text style={styles.optionText}>Support</Text>
        </TouchableOpacity>
      </Animated.View>
      <HelpSupportModal
        isVisible={isSupportModalVisible}
        onClose={closeSupportModal}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    top: 10,
    width: "100%",
  },
  toggleButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 15,
    borderWidth: 1,
    borderColor: "#4299E1",
    borderRadius: 5,
    marginBottom: 10,
  },
  toggleButtonText: {
    color: "#4299E1",
    fontSize: 16,
    fontWeight: "600",
    marginRight: 5,
  },
  optionsContainer: {
    top: 10,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    overflow: "hidden",
  },
  optionButton: {
    width: "48%",
    alignItems: "center",
    marginBottom: 20,
  },
  optionText: {
    color: "#4A5568",
    fontSize: 16,
    marginTop: 5,
    textAlign: "center",
  },
});

export default ExpandableOptions;
